import Inputmask from "inputmask";

export default {
  mounted(el) {
    const im = new Inputmask("+38 (999) 999-99-99", {
      showMaskOnFocus: true,
      showMaskOnHover: false,
      autoUnmask: false,
    });
    im.mask(el);

    el.__phoneMaskInput__ = (e) => {
      let val = e.target.value;

      if (val === "+38") {
        e.target.value = "";
        const event = new Event("input", { bubbles: true });
        e.target.dispatchEvent(event);
      } else if (val.length === 1 && val !== "+") {
        e.target.value = "+38 " + val;
        const event = new Event("input", { bubbles: true });
        e.target.dispatchEvent(event);
      }
    };

    el.addEventListener("blur", el.__phoneMaskInput__);
  },

  unmounted(el) {
    Inputmask.remove(el);
    el.removeEventListener("blur", el.__phoneMaskInput__);
    delete el.__phoneMaskInput__;
  },
};
